export const tango = {
  $01: '#eef1f3',
  $02: '#dce4e8',
  $03: '#d1dbe0',
  $04: '#c5d2d8',
  $05: '#b3c4cc',
  $06: '#9cb2bd',
  $07: '#8ba4b1',
} as const;
